import styled, {css} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {StyledText} from '@/components/ui/text/style'

export const StyledConversationContextHeader = styled(Flexbox)(
    ({theme: {palette, spacing}}) => css`
        background-color: ${palette.neutral.white};
        padding: ${spacing * 3}px ${spacing * 4}px;
        border-bottom: 1px solid ${palette.neutral[200]};
    `
)

/**
 * Marks the line that says why the operator is here. Sized and shaped like the notification
 * list's unread dot, in orange: on this panel it is the one thing asking for attention.
 * The top margin centres it on the first line of a reason that wraps.
 */
export const StyledConversationContextReasonDot = styled.div(
    ({theme: {palette}}) => css`
        min-width: 8px;
        width: 8px;
        height: 8px;
        margin-top: 6px;
        background-color: ${palette.orange['500']};
        border-radius: 50%;
    `
)

const reasonRowStyle = (gap: number) => css`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    text-align: left;
    gap: ${gap}px;
`

export const StyledConversationContextReasonRow = styled.div(
    ({theme: {spacing}}) => css`
        ${reasonRowStyle(spacing * 2)};
    `
)

/**
 * The same line, offered as the way into the conversation the notification is about: the
 * operator reads what happened there and asks to see it in one move.
 *
 * It carries the underline at rest, not on hover: this is the panel's only link, and an
 * affordance nobody can see is one nobody uses. The tone follows the primaryNeutral variant —
 * neutral 950, deepening to 800 the same way its button does — so the line reads as actionable
 * without pulling the eye off the conversation it sits under.
 */
export const StyledConversationContextReasonButton = styled.button(
    ({theme: {palette, spacing}}) => css`
        ${reasonRowStyle(spacing * 2)};
        padding: 0;
        border: none;
        background: none;
        cursor: pointer;

        ${StyledText} {
            color: ${palette.neutral['950']};
            text-decoration: underline;
        }

        &:hover ${StyledText}, &:focus-visible ${StyledText} {
            color: ${palette.neutral['800']};
        }
    `
)
